import { render, staticRenderFns } from "./OrderMonitor.vue?vue&type=template&id=b927e82c&scoped=true"
import script from "./OrderMonitor.vue?vue&type=script&lang=ts"
export * from "./OrderMonitor.vue?vue&type=script&lang=ts"
import style0 from "./OrderMonitor.vue?vue&type=style&index=0&id=b927e82c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b927e82c",
  null
  
)

export default component.exports